import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { classGroupKey } from "@common/helpers/domains/accounting/coaGroupFilter";
import { ChartOfAccountsColumn } from "@common/types/views/chartOfAccountsView";
import type { FiltersTypes } from "@common/types/filters/general";
import type { ChartOfAccountsView } from "@common/types/views/chartOfAccountsView";
import type { NamedView } from "@common/types/views/views";
import { DEFAULT_VIEW_ID } from "@components/views/constants";

export const CHART_OF_ACCOUNTS_1099_MAPPING_VIEW_ID = "1099-mapping";

export const CHART_OF_ACCOUNTS_1099_MAPPING_VIEW_FILTERS: FiltersTypes = {
    coaTemplateGroupKeys: [classGroupKey(AccountClass.expenses)],
};

export type ChartOfAccountsBuiltInViewId =
    | typeof DEFAULT_VIEW_ID
    | typeof CHART_OF_ACCOUNTS_1099_MAPPING_VIEW_ID;

function buildForm1099MappingView(
    defaultView: ChartOfAccountsView,
): ChartOfAccountsView {
    return {
        ...defaultView,
        filters: {
            ...defaultView.filters,
            ...CHART_OF_ACCOUNTS_1099_MAPPING_VIEW_FILTERS,
        },
        columns: [
            { id: ChartOfAccountsColumn.NAME, options: { pin: "left" } },
            { id: ChartOfAccountsColumn.TYPE },
            { id: ChartOfAccountsColumn.FORM_1099_BOX },
            { id: ChartOfAccountsColumn.ENTITIES, options: { pin: "right" } },
            { id: ChartOfAccountsColumn.ACTIONS, options: { pin: "right" } },
        ],
    };
}

const BUILT_IN_VIEW_DEFINITIONS: Record<
    ChartOfAccountsBuiltInViewId,
    {
        name: string;
        build: (defaultView: ChartOfAccountsView) => ChartOfAccountsView;
    }
> = {
    [DEFAULT_VIEW_ID]: { name: "Default", build: (view) => view },
    [CHART_OF_ACCOUNTS_1099_MAPPING_VIEW_ID]: {
        name: "1099 mapping",
        build: buildForm1099MappingView,
    },
};

const BUILT_IN_VIEW_IDS: ChartOfAccountsBuiltInViewId[] = [
    DEFAULT_VIEW_ID,
    CHART_OF_ACCOUNTS_1099_MAPPING_VIEW_ID,
];

export function buildChartOfAccountsBuiltInView({
    defaultView,
    viewId,
}: {
    defaultView: ChartOfAccountsView;
    viewId: ChartOfAccountsBuiltInViewId;
}): ChartOfAccountsView {
    return BUILT_IN_VIEW_DEFINITIONS[viewId].build(defaultView);
}

export function buildChartOfAccountsBuiltInViews(
    defaultView: ChartOfAccountsView,
): Array<NamedView<ChartOfAccountsView>> {
    return BUILT_IN_VIEW_IDS.map((id) => ({
        ...buildChartOfAccountsBuiltInView({ defaultView, viewId: id }),
        id,
        name: BUILT_IN_VIEW_DEFINITIONS[id].name,
    }));
}
